/**
 * Placeholders are replaced by the assets controller
 * [app/server/controllers/assets.js]
 */

const organization = process.env.FLOW_ORGANIZATION;
const pubicKey = process.env.FLOW_PUBLIC_KEY;
const shopifyShop = process.env.SHOPIFY_SHOP;
const shopifyPathPrefix = process.env.SHOPIFY_PATH_PREFIX;
const shopifyCheckoutPathPrefix = process.env.SHOPIFY_CHECKOUT_PATH_PREFIX;

const config = {
  API_BASE_URI: 'https://api.flow.io',
  COOKIE_SESSION_KEY: '_f60_session',
  FLOW_ORGANIZATION: organization || '__FLOW_ORGANIZATION__',
  FLOW_PUBLIC_KEY: pubicKey || '__FLOW_PUBLIC_KEY__',
  SHOPIFY_SHOP: shopifyShop || '__SHOPIFY_SHOP__',
  SHOPIFY_PATH_PREFIX: shopifyPathPrefix || '__SHOPIFY_PATH_PREFIX__',
  SHOPIFY_CHECKOUT_PATH_PREFIX: shopifyCheckoutPathPrefix || '__SHOPIFY_CHECKOUT_PATH_PREFIX__',
};

module.exports = config;



// WEBPACK FOOTER //
// ./static/js/v0/config.js